import { trpc } from "app/core/trpcClient"
import { PaywallPreviewProducts } from "app/paywalls/helpers/types"
import useProductPreviewData from "app/products/hooks/useProductPreviewData"
import { useMemo } from "react"
import useDeviceProperties from "../components/forms/editor/hooks/useDeviceProperties"

const defaultProductPreviewPayload: PaywallPreviewProducts = {
  primary: { identifier: "", locale: { region: "US", language: "en", currency: "USD" } },
  secondary: { identifier: "", locale: { region: "US", language: "en", currency: "USD" } },
  tertiary: { identifier: "", locale: { region: "US", language: "en", currency: "USD" } },
}

type TProps = {
  applicationId: number
  productPreviewPayload?: PaywallPreviewProducts
  userOverride?: Record<string, any>
}

const usePaywallVariables = ({
  applicationId,
  productPreviewPayload = defaultProductPreviewPayload,
  userOverride,
}: TProps) => {
  const { data: userInput } = trpc.userProperties.getUserPropertiesSample.useQuery(
    { applicationId: applicationId! },
    {
      suspense: false,
      enabled: !!applicationId,
    }
  )

  const [deviceProperties] = useDeviceProperties({ applicationId })

  const {
    primary: { identifier: primaryIdentifier, locale: primaryLocale },
    secondary: { identifier: secondaryIdentifier, locale: secondaryLocale },
    tertiary: { identifier: tertiaryIdentifier, locale: tertiaryLocale },
  } = productPreviewPayload

  const primaryInput = useProductPreviewData(applicationId, primaryIdentifier, primaryLocale)
  const secondaryInput = useProductPreviewData(applicationId, secondaryIdentifier, secondaryLocale)
  const tertiaryInput = useProductPreviewData(applicationId, tertiaryIdentifier, tertiaryLocale)

  return useMemo(() => {
    return {
      primary: primaryInput,
      secondary: secondaryInput,
      tertiary: tertiaryInput,
      user: typeof userOverride != "undefined" ? userOverride : userInput,
      device: deviceProperties,
    }
  }, [primaryInput, secondaryInput, tertiaryInput, userInput, userOverride, deviceProperties])
}

export default usePaywallVariables as any
